export const QuestionData = [
  // 가시성 E/I
  {
    id: 1,
    title: "결과물을 다른 사람과 공유하는 것을 좋아하나요?",
    answera: "제가 만든 건 무조건 자랑하고 싶어요!",
    answerb: "잘 만든거라고 해도 남이 보는 건 조금 부담스러워요..",
    type: "EI",
  },
  {
    id: 2,
    title: "디자인을 중요하게 생각하나요?",
    answera: "깔끔하면 보는 사람 기분도 좋아져요!",
    answerb: "기능만 잘 되면 충분하죠",
    type: "EI",
  },

  {
    id: 3,
    title: "시각적으로 확인할 수 있는 것을 선호하나요?",
    answera: "직접 볼 수 있어야 성취한 것 같아요",
    answerb: "보이는 게 다가 아니잖아요",
    type: "EI",
  },
  // 협동심/협동심 없 S/N
  {
    id: 4,
    title:
      "혼자 일하는 것보다 팀으로 일하는 것이 더 효율적이고 재미있다고 생각되나요?  ",
    answera: "팀은 무리..! 혼자가 편해요!",
    answerb: "팀 프로젝트를 하는 일이 즐거워요!",
    type: "NS",
  },
  {
    id: 5,
    title: "타인과 함께 일하는 것이 어렵고 스트레스를 유발한다고 생각하나요?",
    answera: "혼자서 일할 때 효율이 더 늘어요!",
    answerb: "같이 일 할 때 작업 능력이 올라가요!",
    type: "NS",
  },
  {
    id: 6,
    title: "다른 사람들과 협업하여 문제를 해결하는 것에 관심이 있나요?",
    answera: "혼자서 할 때가 문제 해결 시 더 좋은 거 같아요!",
    answerb: "협업하는 게 더 좋은 문제 해결 방법이라 생각해요!",
    type: "NS",
  },
  // 서비스 / 제조 산업 F/T
  {
    id: 7,
    title: "사람들의 반응을 바탕으로 무슨 일을 할 때 의미 있다고 느끼나요?",
    answera: "사람들의 만족도를 살피며 수정과 개선하는것은 아주 중요하죠",
    answerb: "사람들의 반응보다는 정해진 일을 해내는게 좋아요",
    type: "FT",
  },
  {
    id: 8,
    title: "변화하는 것에 적응하고 대처하는 것을 즐기는 편인가요?",
    answera: "빠르게 변화하는 세상은 새롭고 즐거워요!",
    answerb: "변화보다는 안정성을 좋아해요",
    type: "FT",
  },
  {
    id: 9,
    title:
      "완성된 결과물에 대해 만족하는 정도도 중요하지만, 효율성을 더 중요시 하는 편인가요?",
    answera:
      "작업하는데에 있어 시간이 단축되고 생산성이 높은게 득이되는거 같아요!",
    answerb: "그래도 전 결과에 대해 만족하는 여부가 더 중요한거 같아요!",
    type: "FT",
  },
];
